import { render, staticRenderFns } from "./SchedulePostSettings.vue?vue&type=template&id=73a20f55&scoped=true&"
import script from "./SchedulePostSettings.vue?vue&type=script&lang=ts&"
export * from "./SchedulePostSettings.vue?vue&type=script&lang=ts&"
import style0 from "./SchedulePostSettings.vue?vue&type=style&index=0&id=73a20f55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a20f55",
  null
  
)

export default component.exports